import React, { useMemo, useState } from 'react';
import { SearchX } from 'lucide-react';
import { EmailContactCard, EmptyState, FaqAccordion, PageHeader, SearchField, SectionHeader, WhatsAppContactCard } from '@/components/common';
import { HELP_FAQS } from '@/data/helpFaqs';

/** T4 Help & Support: searchable common questions and the two ways to reach us. */
const HelpSupportPage: React.FC = () => {
  const [query, setQuery] = useState('');

  const faqs = useMemo(() => {
    const q = query.trim().toLowerCase();
    return q ? HELP_FAQS.filter((f) => `${f.question} ${f.answer}`.toLowerCase().includes(q)) : HELP_FAQS;
  }, [query]);

  return (
    <div className="tw-flex tw-flex-col tw-gap-6">
      <PageHeader title="Help & Support" subtitle="Answers to common questions, or talk to us directly." />

      <div className="tw-grid tw-items-start tw-gap-5 lg:tw-grid-cols-[minmax(0,640fr)_minmax(0,416fr)] lg:tw-gap-6">
        <section aria-labelledby="faq-heading" className="tw-order-2 tw-flex tw-flex-col tw-gap-5 lg:tw-order-1">
          <SearchField value={query} onChange={setQuery} placeholder="Search help articles" />
          <SectionHeader title="Common questions" />
          {faqs.length ? (
            // Re-mount when the results change so the first match opens.
            <FaqAccordion key={faqs.map((f) => f.id).join()} items={faqs} defaultOpen={faqs[0].id} />
          ) : (
            <EmptyState
              icon={SearchX}
              title="No answers found"
              description="Try different words, or message us on WhatsApp — we’re happy to help."
            />
          )}
        </section>

        {/* Contact cards come first on mobile and tablet (side by side on tablet), as in the design. */}
        <section aria-label="Contact us" className="tw-order-1 tw-grid tw-items-start tw-gap-4 md:tw-grid-cols-2 lg:tw-order-2 lg:tw-flex lg:tw-flex-col lg:tw-items-stretch lg:tw-gap-5">
          <SectionHeader title="Contact us" className="tw-hidden lg:tw-flex" />
          <WhatsAppContactCard title="File or track a claim on WhatsApp" description="The quickest way to file, track or ask about a claim." />
          <EmailContactCard />
        </section>
      </div>
    </div>
  );
};

export default HelpSupportPage;
